export const ASSETS = {
  appLogo: '/assets/ayro_applogo.png',
  banner: '/assets/ayro_banner.png',
  breathingVideo: '/assets/media_breathing.mov',
  iphoneFrame: '/assets/iphone.svg',
  pipVideo: '/assets/media_pip.mov',
  shareCard: '/assets/ayro_share_card.png',
};

export const APP_STORE_URL = 'https://apps.apple.com/us/app/ayro-breathwork/id6776032224';
